import type { ReactElement } from "react";

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  Rect,
} from "@/crossPlatform/react-native-svg";

const GlassesIllustrationSVG = ({
  height,
  width,
}: Partial<SizeDimensions>): ReactElement<Partial<SizeDimensions>, "svg"> => (
  <Svg fill="none" height={height} viewBox="0 0 240 240" width={width}>
    <Rect
      fill="#DCE7FF"
      height="116"
      rx="58"
      width="215.688"
      x="1.28125"
      y="62"
    />
    <G clipPath="url(#clip0_5102_19484)">
      <Path
        d="M70.0203 163.5C82.3278 163.414 93.5576 156.149 99.5583 145.553C106.631 133.063 107.01 117.408 101.438 104.289C96.7417 93.2352 87.508 84.5705 75.225 83.4523C65.1524 82.5357 54.4125 85.6399 45.9503 91.0476C34.6286 98.2947 28.5116 109.892 28.4688 123.256C28.4688 124.826 28.977 129.409 31.316 129.354C33.655 129.299 33.8571 124.551 33.8632 123.128C33.8816 115.862 39.7782 108.377 46.2381 103.874C53.3225 98.9363 61.8582 96.046 70.4918 95.6855C80.2643 95.2761 88.7571 98.9424 94.5006 107.039C100.269 115.16 101.444 124.716 97.1887 133.748C92.2473 144.233 81.2563 151.101 69.7142 151.181C65.9729 151.205 66.1566 163.536 70.0203 163.506V163.5Z"
        fill="#164356"
      />
      <Path
        d="M28.4688 123.257C28.6096 132.618 31.0711 142.376 36.9249 149.856C44.8482 159.975 57.6517 163.335 70.0204 163.5C73.7188 163.549 73.6147 151.224 69.7142 151.175C58.9804 151.029 47.3526 148.585 40.0966 140.018C37.776 137.274 35.9023 133.632 35.1063 131.035C34.843 130.174 34.6103 129.3 34.4021 128.42C34.696 129.685 34.2062 127.271 34.145 126.868C34.0776 126.404 33.8449 123.788 33.9613 125.621C33.9062 124.79 33.8694 123.959 33.8572 123.122C33.8327 121.552 33.3673 116.969 31.0099 117.024C28.6525 117.079 28.4504 121.833 28.4688 123.257Z"
        fill="#164356"
      />
      <Path
        d="M142.524 159.198C151.354 161.288 161.041 159.931 169.025 155.623C176.33 151.682 181.137 145.12 183.574 137.31C188.301 122.175 186.341 103.55 177.298 90.3391C169.809 79.4074 156.326 74.6779 143.455 77.0427C126.818 80.0979 117.389 95.1908 113.911 110.699C111.651 120.781 113.09 132.013 118.277 141.007C123.647 150.313 132.164 156.479 142.518 159.198C145.457 159.968 146.339 147.955 142.212 146.873C134.644 144.887 127.792 140.469 123.181 134.127C121.222 131.432 119.703 128.389 118.883 125.15C118.197 122.45 118.081 120.641 118.424 118.252C120.267 105.463 129.182 92.7588 142.187 89.6975C152.131 87.3571 163.961 89.2697 171.309 96.749C175.528 101.045 178.228 106.465 179.624 112.276C180.831 117.317 180.892 122.431 179.814 127.314C178.338 134.041 174.352 139.73 168.009 143.366C160.312 147.778 150.809 148.896 142.212 146.867C139.181 146.152 138.391 158.22 142.518 159.192L142.524 159.198Z"
        fill="#164356"
      />
      <Path
        d="M184.113 127.436C201.692 114.482 219.272 101.527 236.851 88.5731C238.933 87.0394 238.884 83.2142 238.547 80.9472C238.376 79.8107 237.194 75.1972 235.124 76.7249C217.545 89.6791 199.965 102.633 182.386 115.588C180.304 117.121 180.353 120.946 180.69 123.213C180.861 124.35 182.043 128.963 184.113 127.436Z"
        fill="#164356"
      />
      <Path
        d="M88.1141 99.4134C95.8476 93.7123 103.581 88.0173 111.315 82.3163C113.397 80.7825 113.348 76.9574 113.011 74.6904C112.839 73.5538 111.658 68.9404 109.588 70.468C101.854 76.1691 94.1209 81.8641 86.3874 87.5652C84.3055 89.0989 84.3545 92.9241 84.6913 95.1911C84.8627 96.3276 86.0445 100.941 88.1141 99.4134Z"
        fill="#164356"
      />
      <Path
        d="M103.183 127.919C107.243 128.041 111.272 127.833 115.295 127.295C119.317 126.758 118.528 114.494 114.988 114.971C110.966 115.508 106.937 115.716 102.877 115.594C99.2214 115.484 99.252 127.803 103.183 127.919Z"
        fill="#164356"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_5102_19484">
        <Rect
          fill="white"
          height="93.3438"
          transform="translate(28.4688 70.1562)"
          width="210.25"
        />
      </ClipPath>
    </Defs>
  </Svg>
);

export default GlassesIllustrationSVG;
